import React, { useState, useEffect } from 'react';
import CommonMessage from "../components/CommonMessage";
import { contractCall, web3AccountCheck } from '../helper/web3helper';
import hostContract from '../web3/hostContract.json';
import web3Config from '../web3/web3Config.json';
import { formatEmailDetails, formatMessageList, getWeb2emails } from '../helper/dataFormatHelper';
import Cookies from "universal-cookie";
import { useDispatch, useSelector } from 'react-redux';
import { useWalletReconnectionWithLoader } from '../helper/useWalletReconnection';
import { getEmails, getSentEmails } from '../helper/emailHelper';
import { reportError, toErrorString } from '../utils/errorLogger';
const cookies = new Cookies();

function Archive() {
  const dispatch = useDispatch();
  const [user] = useState(cookies.get("userObject"));
  const [web3Value, setWeb3] = useState(null);
  const [account, setAccount] = useState('');
  const [web3Contract, setWeb3Contract] = useState('');
  const [allBoxList, setAllBoxList] = useState([]);
  const [readList, setReadList] = useState([]);
  const [unreadList, setUnreadList] = useState([]);
  const [loader, setLoader] = useState(true);
  const [rendered, setRendered] = useState(false);
  const userName = user.name;
  const [mailResponse, setMailResponse] = useState([])
  const getRefreshMessage = useSelector((state) => state.refreshMessage);
  const [text, setText] = useState("")
  useEffect(() => {
    web3AccountCheck(setWeb3, setAccount);
  }, []);

  useWalletReconnectionWithLoader(
    setLoader,
    setText,
    web3AccountCheck,
    setWeb3,
    setAccount,
    () => setEmail(),
    web3Contract
  );

  useEffect(() => {
    if (account && web3Value) {
      const contractInstance = contractCall(hostContract.contract, web3Config.CONTRACT);
      setWeb3Contract(contractInstance);
    }
  }, [web3Value, account]);

  useEffect(() => {
    if (web3Contract || getRefreshMessage) {
      setEmail();
    }
  }, [web3Contract, getRefreshMessage]);


  useEffect(() => {
    if (web3Contract) {
      setEmail();
    }
  }, []);

  async function setEmail(loaderRequired = true) {
    // Tracks whether WE turned the loader on, so the finally below only ever clears a loader this call
    // raised — when web3Contract isn't ready yet the initial loader must stay up.
    let loaderShown = false;
    try {
      if (web3Contract) {
        if (loaderRequired) {
          setLoader(true);
          setText("Please wait, data is loading from the blockchain, Going forward it will be fast.")
          setRendered(false);
          loaderShown = true;
        }
        const sentemailList = await getSentEmails(userName);
        const emailList = await getEmails(userName);
        const updatedSentEmailList = await formatEmailDetails(sentemailList);
        const sentformattedResult = updatedSentEmailList.map(email => ({
          mailtype: "Senttrash",
          id: parseInt(email.id),
          subject: email.subject,
          encryptedData: email.encryptedData,
          created_at: email.receivedDate,
          isStarred: email.isStarred,
          sender: email.senderName,
          isRead: email.isRead,
          header: email.emailDetails,
          isCC: email.isCC,
          isBCC: email.isBCC,
          ...email
        })).filter(data => data.isArchive && !data.isDeleted && data.isSaved);
        const sentlist = await formatMessageList(sentformattedResult.reverse(), "Senttrash");
        const filterSentList = sentlist.allList;
        const updatedEmailList = await formatEmailDetails(emailList);
        const formattedResult = updatedEmailList
          .filter(email => email.senderName)
          .map(email => ({
            mailtype: "web3emails",
            id: parseInt(email.id),
            subject: email.subject,
            encryptedData: email.encryptedData,
            created_at: email.receivedDate,
            isStarred: email.isStarred,
            sender: email.senderName,
            isRead: email.isRead,
            header: email.emailDetails,
            isCC: email.isCC,
            isBCC: email.isBCC,
            ...email
          })).filter(data => data.isArchive && !data.isDeleted);
        const { allList } = await formatMessageList(formattedResult.reverse(), "Archive");
        const TotalEmaillist = allList.concat(filterSentList)
        const formattedresponse = await getWeb2emails(userName)
        const list = await formatMessageList(formattedresponse, "Insecure");
        setAllBoxList(allList);
        if (loaderRequired) {
          setRendered(true);
        }
        let responsemail = []
        for (let i = 0; i < list.allList.length; i++) {
          if (list.allList[i].isArchive === true) {
            responsemail.push(
              {
                mailtype: "web2emails",
                ...list.allList[i]
              })
          }
        }
        const emailresponse = responsemail.filter((data) => {
          if (data.delete !== 1 && data.delete !== 3) {
            return data
          }
          return null;
        })
        const sortEmails = (allList, emailresponse) => {
          const combined = [...allList, ...emailresponse];
          const sortedCombined = combined.sort((a, b) => {
            const dateA = new Date(a.date || a.receivedDate);
            const dateB = new Date(b.date || b.receivedDate);
            return dateB - dateA;
          });
          return sortedCombined;
        };
        const sortedresponse = sortEmails(TotalEmaillist, emailresponse);
        setMailResponse(sortedresponse)
        const readListAllEmails = sortedresponse.filter(message => message.isRead);
        const unReadListAllEmails = sortedresponse.filter(message => !message.isRead);
        setReadList(readListAllEmails);
        setUnreadList(unReadListAllEmails);
      }
    } catch (error) {
      const userName = localStorage.getItem('UserName');
      const errorStr = toErrorString(error || error.message);
      reportError({
        endpoint: '-',
        message: `FileName: Archive.js, Fun: setEmail, ${String(error.message || 'Unhandled error')}`,
        error: errorStr,
        userName: userName || '',
      });
      console.log("error", error);
    } finally {
      // The catch above only logged: any throw left the spinner up for good. Clearing here covers both the
      // success and the failure path (setRendered is idempotent).
      if (loaderShown) {
        setRendered(true);
        setLoader(false);
        setText("");
      }
    }

  }
  const refreshCount = useSelector((state) => state.refreshCount);
  const reRender = () => {
    dispatch({ type: "REFRESH_COUNT", payload: !refreshCount });
    setEmail();
  }

  useEffect(() => {
    if (rendered) {
      setLoader(false)
      setText("")
    }
  }, [rendered]);


  return (
    <div className="inbox-container">
      <CommonMessage messageList={mailResponse} unreadList={unreadList} readList={readList} pageType={"Archive"} loader={loader} reRender={reRender} text={text} />
    </div>
  );
}

export default Archive;
